export default "__VITE_ASSET__BHQlkhQL__"